module.exports = ".buttons-controller {\n  margin-top: 20px; }\n\n.mleft {\n  margin-left: 10px; }\n\n.delete-bank-modal {\n  width: 450px; }\n\n.actions {\n  width: 130px;\n  text-align: center; }\n\n.actions button {\n    display: block;\n    margin: 0 auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/legalCertificate/legalCertificate.component.scss
// module id = ./src/app/views/legalCertificate/legalCertificate.component.scss
// module chunks = main